import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGraduate } from '@fortawesome/pro-duotone-svg-icons';
import HeaderComponent from './HeaderComponent';
import FeatureNav from './FeatureNav';
import BreadCrumbs from './BreadCrumbs';
import FooterSection from './FooterSection';
import TeacherPay from "../assets/images/teacher_pay.svg";
import LeaSpending from "../assets/images/lea_spending_and_performance.svg";
import TeacherVsAdminPay from "../assets/images/teacher_vs_admin_pay.svg";
import EducationFunding from "../assets/images/education_funding.svg";
import EntityOverviewPurple from "../assets/images/entity_overview_purple.svg";
import EntityOneOverview from "../assets/images/title_i_program.svg";
import '../assets/styles/main.css';

const PublicEducation = () => {
  return (
    <div className="public-education" id="public-education">
      <HeaderComponent />
      <FeatureNav />
      <BreadCrumbs />
      <main className="mt-20">
        <div className="text-center mb-4">
          <h1 className="display-5 fw-bold mb-3">Public Education (K-12)</h1>
        </div>
        <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
          <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
            <h2 className="text-light">
              <FontAwesomeIcon icon={faUserGraduate} className="me-2" />
              Public Education (K-12)
            </h2>
            <p className="lead">Use these tools to examine performance and spending at K-12 Local Education Agencies (LEA) </p>
          </div>

          <div className="col-12 bg-light ">
            <div className="row justify-content-center">
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov/teacher-pay/" title="Project Kids">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-cool-grey)" }}>Teacher Pay <sup><span
                    className="badge badge-light">New</span></sup></div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={TeacherPay}
                    data-holder-rendered="true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Examine trends in teacher pay across LEAs and schools</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov/spending-map/" title="Project Kids"
                >
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-cool-grey)" }}>Performance and Spending <sup><span
                    className="badge badge-light">New</span></sup></div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={LeaSpending}
                    data-holder-rendered="true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Compare school spending, performance, and demographics in the State of Utah.</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov/lea-pay/" title="Project Kids"
                >
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-cool-grey)" }}>Aaron Bullen's Administrator & Teacher Pay <sup><span
                    className="badge badge-light">New</span></sup></div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={TeacherVsAdminPay}
                    data-holder-rendered="true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">We would like to thank Aaron Bullen for his suggestion of this dashboard. It compares teacher, administrator, and support staff compensation trends.</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov/lea-revenue/" title="Project Kids"
                >
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-cool-grey)" }}>Jamie Renda's Utah Education Funding <sup><span
                    className="badge badge-light">New</span></sup></div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={EducationFunding}
                    data-holder-rendered="true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">We would like to thank Jamie Renda (Path Forward Utah) for her suggestion of this dashboard. It explores how schools in Utah are funded.</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov/entities/entity-overview-dashboard" title="Entity Overview">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Entity Overview </div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={EntityOverviewPurple}
                    data-holder-rendered="true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">View LEA revenue, expenditure, and if an LEA has a surplus/deficit</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://old.transparent.utah.gov/pkids_title_i.php" title="Project Kids"
                >
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Title I Program Effectiveness <sup><span
                    className="badge badge-dark">Legacy</span></sup> </div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={EntityOneOverview}
                    data-holder-rendered="true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Learn about spending performance trends at Title I schools</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://old.transparent.utah.gov/pkids_legacy_dashboards_menu.php" title="Project Kids"
                >
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Other Legacy Dashboards?</div>
                  <div className="card-body py-0 ">
                    <p className="card-text text-center mt-2">Legacy dashboards are still accessible, but not updated. The "Performance and Spending" dashboard replaces the legacy tools</p>
                    <div className="card-body py-0 d-flex justify-content-center">
                      <div className="btn btn-secondary text-center">Visit Legacy Dashboards</div>
                    </div>
                  </div>
                </a>
              </article>
            </div>
          </div>
        </div>
      </main>
      <FooterSection />
    </div>
  )
}

export default PublicEducation;